"use client";
import styles from './styles.module.scss';
import Link from 'next/link';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { useTheme } from '@/providers/themeProvider';

const BrandBanner = (props) => {
	const { cta } = props || {};
	const { theme } = useTheme();

	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	// ✅ Wait for mount to avoid hydration mismatch
	if (!isMounted) return null;

	const getImageSrc = (lightSrc, darkSrc) =>
		theme === 'light' ? lightSrc : darkSrc;

	const renderCta = () => {
		const { url } = cta || {};
		if (!url) return null;

		return (
			<Link href={url} className={`${styles.brandBanner__cta} button large transparent-fill`}>
				{cta?.title}
			</Link>
		);
	};

	return (
		<section className={styles.brandBanner}>
			<div className="container">
				<div className={`${styles.brandBanner__inner} random-grid-dark-fade-top-center`}>
					<div className={styles.brandBanner__grid}>
						{[
							{
								href: "https://www.clubautomation.com/",
								light: "/new_logos/new_ca_light_bg.png",
								dark: "/new_logos/new_ca_dark_bg.png",
								width: 5523,
								height: 876,
								alt: "Club Automation Logo",
								className: "clubauto"
							},
							{
								href: "https://zenplanner.com/",
								light: "/new_logos/new_zp_light_bg.png",
								dark: "/new_logos/new_zp_dark_bg.png",
								width: 4179,
								height: 876,
								alt: "Zen Planner Logo"
							},
							{
								href: "https://reclique.com/",
								light: "/new_logos/new_core_light_bg.png",
								dark: "/new_logos/new_core_dark_bg.png",
								width: 2054,
								height: 876,
								alt: "Daxko Core Logo",
								className: "core"
							},
							{
								href: "https://www.sugarwod.com/",
								light: "/new_logos/new_sw_light_bg.png",
								dark: "/new_logos/new_sw_dark_bg.png",
								width: 3979,
								height: 876,
								alt: "SugarWOD Logo"
							},
							{
								href: "https://www.clubautomation.com/engage-pro/",
								light: "/new_logos/new_ep_light_bg.png",
								dark: "/new_logos/new_ep_dark_bg.png",
								width: 4068,
								height: 876,
								alt: "Engage Pro Logo"
							},
							{
								href: "https://www.motionsoft.net/",
								light: "/new_logos/new_ms_light_bg.png",
								dark: "/new_logos/new_ms_dark_bg.png",
								width: 3979,
								height: 876,
								alt: "Motionsoft Logo"
							}
						].map(({ href, light, dark, width, height, alt, className }, i) => (
							<div key={i} className={`${styles.brandBanner__image} ${className || ''}`}>
								<Link href={href} target="_blank">
									<Image
										src={getImageSrc(light, dark)}
										width={width}
										height={height}
										alt={alt}
										priority
									/>
								</Link>
							</div>
						))}
					</div>
					<div>{renderCta()}</div>
				</div>
			</div>
		</section>
	);
};

export default BrandBanner;
